/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import CardsContainer, { Cards } from './Cards';

/**
 * Cards module exports
 */
export {
    Cards,
    CardsContainer as default
};



// WEBPACK FOOTER //
// ./src/js/Cards/index.js